<h2 mat-dialog-title>Select a reason for Denial.</h2>

<mat-dialog-content>
  <p>Please select a reason for denying the vendor.</p>

  <form [formGroup]="vendorDenialForm" class="flex flex-col">
    <mat-radio-group aria-label="Select an option" formControlName="reason" class="flex flex-col mt-4 mb-4"> 
      @for (reason of reasonOptions; track reason) {
        <mat-radio-button [value]="reason">{{ reason }}</mat-radio-button>
      }
    </mat-radio-group>

    @if (otherReason) {
      <mat-form-field>
        <mat-label>Other Reason</mat-label>
        <input
          matInput
          type="text"
          formControlName="otherReason"
          placeholder="Other"
          maxlength=""
        />
      </mat-form-field>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="accent" (click)="onDeny()" [disabled]="!reasonProvided">Submit</button>
</mat-dialog-actions>
